/*
 * Copyright (c) 2020. Sayari LLC
 */

import {LoginUser} from '../models/login.user';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class LoginService {
    authSuccess = true;
    helper = new JwtHelperService();
    public static get ACCESS_TOKEN(): string { return 'access_token'; }
    constructor(private httpClient: HttpClient, private router: Router) {}

    login(loginUser: LoginUser): boolean {
        loginUser.grantType = 'password';
        const payload = new HttpParams()
            .set('username', loginUser.username)
            .set('password', loginUser.password)
            .set('grant_type', loginUser.grantType);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Basic ' + btoa('mobile_client:'))
            .append('Content-Type', 'application/x-www-form-urlencoded')
            // .append('Access-Control-Allow-Origin', '*')
            .append('Accept', 'application/json');

        const options = {
            headers: headers,
            observe: 'response' as 'body' // 'observe response' returns the full response (i.e status, body, headers etc)
        };
        const httpResponse = this.httpClient.post<any>(environment.apiUrl + '/oauth/token', payload, options);
        httpResponse.subscribe(data => {
            const statusCode = data.status;
            if (statusCode === 200) {
                const accessToken = data.body['access_token'];
                localStorage.setItem(LoginService.ACCESS_TOKEN, accessToken);
                const decodedToken = this.helper.decodeToken(accessToken);
                this.router.navigateByUrl('/admin');
            } else {
                this.authSuccess = false;
            }
        });
        return this.authSuccess;
    }
}
